import { HttpClient, HttpMethods } from "../types/httpClient";
import { EditDocument } from "@planzone/dto";

function getDocumentEditionToken(httpClient: HttpClient) {
  return (
    documentData: EditDocument,
    username: string,
    userid: string,
    callbackUrl: string,
  ) =>
    httpClient.sendHttpRequest<{ token: string }>({
      endpoint: `/onlyOffice/generateJwt`,
      method: HttpMethods.POST,
      data: {
        documentData,
        username,
        userid,
        callbackUrl,
      },
    });
}

export { getDocumentEditionToken };
